import { Form, Formik, FormikErrors, FormikProps } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import buildingsApi from '../../../APIs/buildings';
import printerApi from '../../../APIs/printer';
import { ReactComponent as CloseSVG } from '../../../assets/icons/cross.svg';
import {
  Button,
  Divider,
  FormContainer,
  Input,
  ListImage,
  TextArea,
  Typography,
} from '../../../designComponents';
import { RootState } from '../../../store/selectors';
import { requestAPI } from '../../../utils';
import {
  AdditionalReqContainerStyled,
  CloseAdditionalWrapperStyled,
  CreatePrinterJobsContainerStyled,
  PDFWithQuantityContainerStyled,
} from './style';
import {
  AdditionalRequirementType,
  InitialValuesType,
  ParamsType,
} from './type';
import { createPrinterJobsValidation } from './validation';

const AddPrinterJob = ({
  onClose,
  pdfs,
  jobId,
  jobProcessId,
}: {
  jobId: string;
  jobProcessId: string;
  onClose: () => void;
  pdfs?: {
    url: string;
  }[];
}) => {
  const formikRef = useRef<FormikProps<InitialValuesType>>(null);
  // const [approvedPrinters, setApprovedPrinters] = useState<any>([]);
  const [initialValues] = useState<InitialValuesType>({
    jobTitle: '',
    pdfId: '',
    printerName: '',
    printerId: '',
    // buildingId: '',
    notes: '',
    pdfs:
      pdfs?.map((pdf) => ({
        url: pdf.url,
        quantity: 0,
      })) ?? [],
    shippingAddress: '',
    additionalRequirement: [],
    quantity: [],
  });

  const pagination = useSelector(
    (state: RootState) => state.buildings.pagination
  );

  // const buildings: BuildingType[] = useSelector(
  //   (state: RootState) => state.buildings.data
  // );

  // const handleGetBuildings = async (myParams: ParamsType) => {
  //   try {
  //     await requestAPI(
  //       buildingsApi.getBuildings({
  //         page: myParams.page,
  //         limit: myParams.limit,
  //       })
  //     );
  //   } catch (error) {
  //     console.error('Error fetching buildings:', error);
  //   }
  // };

  // useEffect(() => {
  //   handleGetBuildings(pagination);
  // }, []);
  // useEffect(() => {
  //   getApprovedPrinters();
  // }, []);
  // const getApprovedPrinters = async () => {
  //   try {
  //     const response = await requestAPI(printerApi.getAllPrinter());
  //     setApprovedPrinters(response.data);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  const handleCreateJobs = async (values: InitialValuesType) => {
    try {
      await requestAPI(
        printerApi.postPrinterJob({
          ...values,
          technicianJobId: jobId,
          jobProcessId,
          pdf: values.pdfs,
        })
      );
      toast('Successfully Created Printer Job');
      onClose();
    } catch (error) {
      toast('Error Try again later');
    }
  };

  const handleAddAdditionalRequirement = () => {
    if (formikRef?.current) {
      const additionalReq: AdditionalRequirementType[] =
        formikRef.current.values.additionalRequirement;
      const newReq = {
        title: '',
        value: '',
        id: additionalReq.length + 1,
      };
      formikRef.current.setFieldValue('additionalRequirement', [
        ...additionalReq,
        newReq,
      ]);
    }
  };

  const handleRemoveAdditionalRequirement = (idx: number) => {
    if (formikRef?.current) {
      const additionalReq: AdditionalRequirementType[] = [
        ...formikRef.current.values.additionalRequirement,
      ];

      additionalReq.splice(idx, 1);

      formikRef.current.setFieldValue('additionalRequirement', additionalReq);
    }
  };

  return (
    <CreatePrinterJobsContainerStyled
      style={{
        display: 'flex',

        flexDirection: 'column',
        maxWidth: '90vw',
        maxHeight: '70vh',
        overflow: 'auto',
        background: 'white',
        borderRadius: '8px',
        padding: '16px',
      }}
    >
      <Typography variant="title" className="heading">
        Create Job for Printer
      </Typography>
      <Formik
        innerRef={formikRef}
        onSubmit={handleCreateJobs}
        initialValues={initialValues}
        validationSchema={createPrinterJobsValidation}
        validateOnChange={true}
        validateOnBlur={true}
      >
        {({ values, setFieldValue, touched, errors }) => {
          const isQuantityErrorArray = (
            errorObj: unknown
          ): errorObj is FormikErrors<{
            pdfId: string;
            quantity: string;
          }>[] => {
            return Array.isArray(errorObj);
          };

          return (
            <Form>
              <FormContainer
                label="Job Title"
                error={touched.jobTitle ? errors.jobTitle : ''}
              >
                <Input
                  placeholder="PDF Name"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const { value } = e.target;
                    setFieldValue('jobTitle', value);
                  }}
                  value={values.jobTitle}
                />
              </FormContainer>

              <FormContainer
                label="Notes"
                error={touched.notes ? errors.notes : ''}
              >
                <TextArea
                  value={values.notes}
                  onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                    const { value } = e.target;
                    setFieldValue('notes', value);
                  }}
                  placeholder="Notes"
                  showCount
                  maxLength={160}
                />
              </FormContainer>
              {values.pdfs && (
                <PDFWithQuantityContainerStyled>
                  {values.pdfs.map((pdf, idx) => (
                    <div className="individual-pdf-row" key={idx}>
                      <ListImage
                        imagesURL={[
                          {
                            id: String(idx),
                            URL:
                              pdf?.url ||
                              'https://cdn.pixabay.com/photo/2018/05/08/18/46/pdf-3383632_1280.png',
                          },
                        ]}
                        imageHeight="143px"
                        imageWidth="192px"
                        enablePreview={false}
                      />

                      <FormContainer
                        label="Printing Quantity"
                        error={
                          Array.isArray(touched?.pdfs) &&
                          touched.pdfs[idx]?.quantity &&
                          Array.isArray(errors?.pdfs)
                            ? (
                                errors.pdfs[idx] as FormikErrors<{
                                  url: string;
                                  quantity: number;
                                }>
                              )?.quantity
                            : ''
                        }
                      >
                        <Input
                          type="number"
                          value={pdf?.quantity ?? 0}
                          min={0}
                          max={100}
                          placeholder="Printing Quantity"
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            const value = e.target.value;
                            const numericValue = Number(value);

                            if (
                              value === '' ||
                              (numericValue >= 0 && numericValue <= 100)
                            ) {
                              const updatedPdfs = [...values.pdfs];
                              updatedPdfs[idx] = {
                                ...updatedPdfs[idx],
                                quantity: value === '' ? 0 : numericValue,
                              };
                              setFieldValue('pdfs', updatedPdfs);
                            }
                          }}
                        />
                      </FormContainer>
                    </div>
                  ))}
                </PDFWithQuantityContainerStyled>
              )}

              <FormContainer
                label="Shipping Address"
                error={touched.shippingAddress ? errors.shippingAddress : ''}
              >
                <Input
                  value={values.shippingAddress}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const { value } = e.target;
                    setFieldValue('shippingAddress', value);
                  }}
                  placeholder="Shipping address"
                />
              </FormContainer>

              <AdditionalReqContainerStyled
                $hasAdditional={values.additionalRequirement.length > 0}
              >
                {values?.additionalRequirement?.map((val, idx) => {
                  return (
                    <div key={`${val.id}-${idx}`}>
                      <CloseAdditionalWrapperStyled>
                        <CloseSVG
                          onClick={() => handleRemoveAdditionalRequirement(idx)}
                        />
                      </CloseAdditionalWrapperStyled>
                      <FormContainer
                        label={`Additional Requirement Title ${idx + 1}`}
                        error={
                          touched?.additionalRequirement?.[idx]?.title &&
                          errors?.additionalRequirement
                            ? (
                                errors.additionalRequirement[
                                  idx
                                ] as FormikErrors<{
                                  title: string;
                                  value: string;
                                  id: number;
                                }>
                              )?.title
                            : ''
                        }
                      >
                        <Input
                          placeholder="Please enter a title"
                          value={values.additionalRequirement[idx].title}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            const { value } = e.target;
                            const updatedValues = [
                              ...values.additionalRequirement,
                            ];
                            updatedValues[idx].title = value;

                            setFieldValue(
                              'additionalRequirement',
                              updatedValues
                            );
                          }}
                        />
                      </FormContainer>
                      <FormContainer
                        label={`Additional Requirement Description ${idx + 1}`}
                        error={
                          touched?.additionalRequirement?.[idx]?.value &&
                          errors?.additionalRequirement
                            ? (
                                errors.additionalRequirement[
                                  idx
                                ] as FormikErrors<{
                                  title: string;
                                  value: string;
                                  id: number;
                                }>
                              )?.value
                            : ''
                        }
                      >
                        <TextArea
                          value={values.additionalRequirement[idx].value}
                          onChange={(
                            e: React.ChangeEvent<HTMLTextAreaElement>
                          ) => {
                            const { value } = e.target;
                            const updatedValues = [
                              ...values.additionalRequirement,
                            ];
                            updatedValues[idx].value = value;

                            setFieldValue(
                              'additionalRequirement',
                              updatedValues
                            );
                          }}
                          placeholder="Please enter your requirement"
                          showCount
                          maxLength={160}
                        />
                      </FormContainer>
                      <Divider />
                    </div>
                  );
                })}
                <Button
                  variant="gray"
                  size="sm"
                  onClick={handleAddAdditionalRequirement}
                  type="button"
                >
                  Additional Requirement
                </Button>
              </AdditionalReqContainerStyled>

              <Button
                variant="secondary"
                size="lg"
                style={{
                  padding: '7px 30px',
                }}
                htmlType="submit"
              >
                Continue
              </Button>
            </Form>
          );
        }}
      </Formik>
    </CreatePrinterJobsContainerStyled>
  );
};

export default AddPrinterJob;
